import { render, staticRenderFns } from "./OnboardPricingForm.vue?vue&type=template&id=1c8292ac&scoped=true&"
import script from "./OnboardPricingForm.vue?vue&type=script&lang=ts&"
export * from "./OnboardPricingForm.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardPricingForm.vue?vue&type=style&index=0&id=1c8292ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8292ac",
  null
  
)

export default component.exports